import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Label } from '@grandvisionhq/elements';

const PrescriptionDownloadItem = ({ downloadUrl , downloadLabel , expiryDate , isValid , prescriptionType , fullName , onDownload ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "prescription-download-item"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "prescription-download-item__row"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "prescription-download-item__strong"
    }, prescriptionType), /*#__PURE__*/ React.createElement(Link, {
        onClick: onDownload,
        url: downloadUrl,
        target: "_blank",
        className: "prescription-download-item__link"
    }, downloadLabel)), fullName && /*#__PURE__*/ React.createElement("div", {
        className: "prescription-download-item__row"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "prescription-download-item__strong"
    }, fullName)), /*#__PURE__*/ React.createElement("div", {
        className: "prescription-download-item__row"
    }, /*#__PURE__*/ React.createElement(Label, {
        type: isValid ? 'success' : 'neutral'
    }, expiryDate)));
};
var PrescriptionDownloadItem$1 = PrescriptionDownloadItem;

export { PrescriptionDownloadItem$1 as default };
//# sourceMappingURL=PrescriptionDownloadItem.js.map
